import { AnyAction } from "redux";
import { initialMechanicListState } from "./mechanicList.state";
import {
  FETCH_MECHANIC_LIST_FAILED,
  FETCH_MECHANIC_LIST_PROGRESS,
  FETCH_MECHANIC_LIST_SUCCESS,
  IMechanic,
  IMechanicListState,
  SET_MECHANIC_LIST_FILTERS,
  UPSERT_MECHANIC_SUCCESS,
} from "./mechanicList.types";

export const mechanicListReducer = (
  state: IMechanicListState = initialMechanicListState,
  action: AnyAction
): IMechanicListState => {
  switch (action.type) {
    case FETCH_MECHANIC_LIST_PROGRESS:
      return {
        ...state,
        loading: true,
      };

    case FETCH_MECHANIC_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.data || [],
        totalRecords: action.payload.totalRecords || 0,
      };

    case FETCH_MECHANIC_LIST_FAILED:
      return {
        ...state,
        loading: false,
      };

    case UPSERT_MECHANIC_SUCCESS: {
      const updatedItem = action.payload;
      const existsIndex = state.list.findIndex((item: IMechanic) => String(item.id) === String(updatedItem.id));
      let newList = [...state.list];

      if (existsIndex >= 0) {
        newList[existsIndex] = { ...newList[existsIndex], ...updatedItem };
      } else {
        newList = [updatedItem, ...newList];
      }

      return {
        ...state,
        list: newList,
        totalRecords: newList.length,
      };
    }

    case SET_MECHANIC_LIST_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};
